import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    flex-direction: column;
    width: 100%;
`;

export const IconWrapper = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 60px;
    background-color: ${COLORS.BgSurface};
    justify-content: center;
    align-content: center;
    margin-bottom: 16px;
`;

